export default __webpack_public_path__ + "cigareta.png?e1dfa31b2c44c5627572eb37ab916d0f";